<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid
      .column.is-widescreen-4
        AppTitle.u-mb-xs(:title="$t('tools')" tag="h2")
        p.u-text-lg.u-mb-xs {{$t('toolsDesc')}}
        .u-mb-mi
          AppLink(to="/tools" class="button-link hide-desktop " :title="$t('viewMore')") {{ $t('viewMore') }}
      .column.is-widescreen-8
        .grid.is-middle
          .column.is-tablet-5
            AppCard.is-work( :img="[{ srcset: '{CDN_URL}/new/grid-maker@2x.webp 2x, {CDN_URL}/new/grid-maker.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/new/grid-maker@2x.png 2x, {CDN_URL}/new/grid-maker.png 1x', type: 'image/png' }]"  ratio="4:5" :title="$t('gridMaker')"  url="/tools/grids" )
          .column.is-tablet-7
            AppCard.is-work(:img="[{ srcset: '{CDN_URL}/new/aspect-ratio@2x.webp 2x, {CDN_URL}/new/aspect-ratio.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/new/aspect-ratio@2x.png 2x, {CDN_URL}/new/aspect-ratio.png 1x', type: 'image/png' }]"  ratio="3:2" :title="$t('aspectRatio')"  url="/tools/ratios" )
        AppLink(to="/tools" class="button-link show-desktop" :title="$t('viewMore')") {{ $t('viewMore') }}

  section.u-mt-md
    .grid
      .column.is-widescreen-4
        AppTitle.u-mb-xs(:title="$t('resources')" tag="h2")
        p.u-text-lg.u-mb-xs {{$t('resourcesDesc')}}
        .u-mb-mi
          AppLink(to="/resources" class="button-link hide-desktop " :title="$t('viewMore')") {{ $t('viewMore') }}
      .column.is-widescreen-8
        .grid.is-middle
          .column.is-tablet-5
            AppCard.is-work( img="https://baianat.s3.amazonaws.com/resources/Stark_1547157634280_2bb1ta.png" ratio="4:5" :title="$t('stark')" url="/resources/stark" )
          .column.is-tablet-7
            AppCard.is-work( img="https://baianat.s3.amazonaws.com/resources/Large_1547157640288_y7u5mj.png" ratio="3:2" :title="$t('large')" url="/resources/large" )
        AppLink(to="/resources" class="button-link show-desktop" :title="$t('viewMore')") {{ $t('viewMore') }}

  section.u-mt-md
    .grid
      .column.is-widescreen-4
        AppTitle.u-mb-xs(:title="$t('openSource')" tag="h2")
        p.u-text-lg.u-mb-xs {{$t('openSourceDesc')}}
        .u-mb-mi
          AppLink(to="/opensource" class="button-link hide-desktop " :title="$t('viewMore')") {{ $t('viewMore') }}
      .column.is-widescreen-8
        .grid.is-middle
          .column.is-tablet-7
            AppCard.is-work( img="https://baianat.s3.amazonaws.com/resources/Align_1547305795600_75lw8.png" ratio="3:2" :title="$t('align')" url="/opensource/align" )
          .column.is-tablet-5
            AppCard.is-work( img="https://baianat.s3.amazonaws.com/resources/sadsa_1547305806440_h9mwhp.png" ratio="4:5" :title="$t('board')" url="/opensource/board" )
        AppLink(to="/opensource" class="button-link show-desktop" :title="$t('viewMore')") {{ $t('viewMore') }}

  //- section.u-mt-md
  //-   .grid
  //-     .column.is-widescreen-4
  //-       AppTitle.u-mb-xs(:title="$t('books')" tag="h2")
  //-       p.u-text-lg.u-mb-xs {{$t('booksDesc')}}
  //-       .u-mb-mi
  //-         AppLink(to="/books" class="button-link hide-desktop " :title="$t('viewMore')") {{ $t('viewMore') }}
  //-     .column.is-widescreen-8
  //-       .grid.is-middle
  //-         .column.is-tablet-6
  //-           AppCard.is-work( img="https://cdn.baianat.com/books/the-game/thegame_1553954284291_tp9ci.jpg" ratio="4:5" :title="$t('theGame')" url="/books/the-game" )
  //-         .column.is-tablet-6
  //-           AppCard.is-work( img="https://cdn.baianat.com/books/merits-of-design-systems/cover1_1554055851665_sbvdrp.jpg" ratio="4:5" :title="$t('designSystem')" url="/books/merits-of-design-systems" )
  //-       AppLink(to="/books" class="button-link show-desktop" :title="$t('viewMore')") {{ $t('viewMore') }}

  .u-mb-mi

</template>

<script>
import SocialCard from '~/components/SocialCard';
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  meta: {
    theme: 'dark atlas',
    logoText: 'Hubs'
  },
  components: {
    SocialCard
  },
  head: generateSeoMeta(
    {
      title: 'pageTitle',
      description: 'pageDesc'
    },
    { i18n: true }
  )
};
</script>

<style lang="stylus">
.app.is-atlas
  overflow: hidden

  .hide-desktop
    +mq($until: 'desktop')
      display: none

  .show-desktop
    +mq($from: 'desktop')
      display: none
</style>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Hubs",
    "pageDesc":"Projects and tools made by Baianaters to support designers, developers, strategists and techies around the world.",
    "pageImg":"/share/atlas.png",
    "mantra":"Tools, hubs and |internal projects.",
    "hubs":"Hubs",
    "hubsDesc":"Projects, explorations carried by Baianat team to the world of creatives.",
    "tools":"Tools",
    "toolsDesc":"Variety of handy tools to help you get your work done faster. Use it online and download the results in the format your prefer.",
    "resources":"Resources",
    "resourcesDesc":"Visual resources created for designers. From Icons to UI mockups, explore and download whatever you need.",
    "openSource":"Open source",
    "openSourceDesc":"Baianat libraries created to support developers in their coding process and cut off the time needed for mobile or web development processes.",
    "panorama":"Panorama",
    "egyptos":"Egyptos",
    "gridMaker":"Grids",
    "aspectRatio":"Ratios",
    "spectrum":"Spectrum",
    "quotes":"Quotes",
    "posters":"Posters",
    "stark":"Stark",
    "large":"Large",
    "veeValidate":"Vee Validate",
    "align":"Align",
    "board":"Board",
    "soon": "Soon",
    "colors":"Colors",
    "colorsDesc":"Experience the different possibilities of colors through AI powered tools that create, mix and help you customize color palettes to your needs.",
    "atlas":"Atlas",
    "atlasDesc":"Explore projects and tools made by Baianaters for the world.",
    "models":"Models",
    "modelsDesc":"We create models and diagrams across the different industries to visualize concepts and provide a better thinking methodology.",
    "books":"Books",
    "booksDesc":"Comprehensive resource for in depth in the fields of business, design, development, and technology.",
    "theGame":"The game",
    "designSystem":"The merits of design system"
  },
  "ar": {
    "pageTitle":"المراكز",
    "pageDesc":"تصفح مراكز بيانات التي تتضمن مجموعة متنوعة من الأفكار والأدوات وتصميمات المجانية والمصادر المفتوحة التي تساعدك في أعمالك.",
    "pageImg":"/share/atlas.png",
    "mantra":"مشاريع وأدوات من |بيانات إلى العالم.",
    "hubs":"المراكز",
    "hubsDesc":"مشاريع ومبادرات متنوعة قام فريق بيانات بتصميمها من أجل العالم.",
    "tools":"الأدوات",
    "toolsDesc":"مجموعة متنوعة من الأدوات التي تساعدك على إنجاز أعمالك بشكل أسرع. استخدمها عبر الانترنت ثم قم بتحميل النتائج على الفور.",
    "resources":"تصميمات مجانية",
    "resourcesDesc":"عناصر بصرية تم تصميمها خصيصًا من أجل مصممين، يشمل الأيقونات وواجهة المستخدم والقوالب، استكشف وحمل ما تريد.",
    "openSource":"المصادر المفتوحة",
    "openSourceDesc":"تم إنشاء المصادر المفتوحة من أجل دعم المبرمجين في عملياتهم وتقليل الوقت والمجهود سواء لمبرمجى التطبيقات أو الويب.",
    "panorama":"بانوراما",
    "panoramaDesc":"شاهد العالم من وجهة نظر بيانات. القِ نظرة أكثر تفصيلًا على المعالم المختلفة التي أعدنا رسمها رقميًا.",
    "egyptos":"ايجيبتوس",
    "egyptosDesc":"شاهد جمال مصر من خلال رسمنا لمدنها ومعالمها المهمة باستخدام هوية مميزة تجمع ما بين الماضي والحاضر.",
    "gridMaker":"الشبكات",
    "aspectRatio":"النسب",
    "spectrum":"سبكترام",
    "quotes":"الاقتباسات",
    "posters":"البوسترات",
    "stark":"ستارك",
    "large":"لارج",
    "veeValidate":"Vee Validate",
    "align":"Align",
    "board":"Board",
    "soon": "قريباً",
    "colors":"الألوان",
    "colorsDesc":"جرب الإمكانات المختلفة للألوان من خلال الأدوات التي تعتمد على الذكاء الاصطناعي، حيث تساعدك على تكوين ودمج لوحة ألوانك وفقًا لاحتياجاتك.",
    "atlas":"أطلس",
    "atlasDesc":"ابدأ في بناء قاعدة معرفتك من خلال أطلس الذي يضُم المصطلحات والكلمات والاختصارات الرئيسية التي تحتاج إليها في مجالك.",    "models":"النماذج",
    "modelsDesc":"نقوم بإنشاء نماذج ومخططات عبر الصناعات المختلفة من أجل رسم الأفكار والمفاهيم لتوفير منهجية أفضل في التفكير أثناء العمل. ",
    "books":"الكتب",
    "booksDesc":"مصادر شاملة وأكثر تعمقًا في مجالات البيزنس والتصميم والبرمجة والتكنولوجيا.",
    "theGame":"اللعبة",
    "designSystem":"مزايا أنظمة التصميم"


  }
}
</i18n>
